import { render, staticRenderFns } from "./LayerExtraAttributesManager.vue?vue&type=template&id=5c8ae516"
import script from "./LayerExtraAttributesManager.vue?vue&type=script&lang=js"
export * from "./LayerExtraAttributesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports